// src/app/page.tsx
import { FC, useEffect, useState } from "react";
import { Avatar } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Logo from "../../../assets/images/logo.svg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "./index.css";
import { useParams } from "react-router-dom";
import Costs from "./Costs";
import Chat from "./Chat";
import Memory from "./Memory";
import Automations from "./Automations";

const EditBot: FC = () => {
  const robots = [
    { name: "Bo", id: 1 },
    { name: "Talha", id: 2 },
    { name: "Ana", id: 3 },
    { name: "Sam", id: 4 },
  ]; // this will come from redux store
  const params: { id?: number } = useParams();

  return (
    <div className="update-robot page-content">
      <Grid
        container
        alignItems={"center"}
        sx={{ height: "10%", margin: { md: "0px -3vw" } }}
      >
        <Grid size={{ xs: 2, md: 1 }} textAlign={"center"}>
          <div className="bot-avatar-img">
            <Avatar
              alt="Remy Sharp"
              sx={{
                objectFit: "contain",
                backgroundColor: "#2a945f",
              }}
            >
              <img src={Logo} className="bot-avatar" />
            </Avatar>
          </div>
        </Grid>
        <Grid size={{ xs: 8, md: 10 }}>
          {params &&
          robots.find((robot) => robot.id == (params && params.id)) ? (
            <div className="robot-name">
              {robots.find((robot) => robot.id == (params && params.id))?.name}
            </div>
          ) : null}
        </Grid>
        <Grid size={{ xs: 2, md: 1 }}>
          <div className="remove-bot">
            <DeleteOutlineIcon sx={{ color: "#2a945f" }} />
          </div>
        </Grid>
      </Grid>
      <Costs />
      <Chat />
      <Memory />
      <Automations />
    </div>
  );
};

export default EditBot;
